import { RECEIPT, PAYMENT } from 'constants/types';
import { dispatcher, api } from '@unicus/react-ui-kit';

export const FINANCIALSTATISTIC = 'FINANCIALSTATISTIC';

export const FINANCIALSTATISTIC_GET_TOP_RECEIPT_CATEGORIES =
  'FINANCIALSTATISTIC_GET_TOP_RECEIPT_CATEGORIES';
export const FINANCIALSTATISTIC_GET_TOP_RECEIPT_CATEGORIES_FINISHED =
  'FINANCIALSTATISTIC_GET_TOP_RECEIPT_CATEGORIES_FINISHED';

export const FINANCIALSTATISTIC_GET_TOP_PAYMENT_CATEGORIES =
  'FINANCIALSTATISTIC_GET_TOP_PAYMENT_CATEGORIES';
export const FINANCIALSTATISTIC_GET_TOP_PAYMENT_CATEGORIES_FINISHED =
  'FINANCIALSTATISTIC_GET_TOP_PAYMENT_CATEGORIES_FINISHED';

export const FINANCIALSTATISTIC_GET_TOTAL_LAST_MONTH =
  'FINANCIALSTATISTIC_GET_TOTAL_LAST_MONTH';
export const FINANCIALSTATISTIC_GET_TOTAL_LAST_MONTH_FINISHED =
  'FINANCIALSTATISTIC_GET_TOTAL_LAST_MONTH_FINISHED';

export const FINANCIALSTATISTIC_GET_SUMMARY = 'FINANCIALSTATISTIC_GET_SUMMARY';
export const FINANCIALSTATISTIC_GET_SUMMARY_FINISHED =
  'FINANCIALSTATISTIC_GET_SUMMARY_FINISHED';

export const FINANCIALSTATISTIC_GET_CASHFLOW =
  'FINANCIALSTATISTIC_GET_CASHFLOW';
export const FINANCIALSTATISTIC_GET_CASHFLOW_FINISHED =
  'FINANCIALSTATISTIC_GET_CASHFLOW_FINISHED';

export const getReceiptTopCategories = (params, onSuccess) => async (
  dispatch
) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'financialStatistics',
    actionType: FINANCIALSTATISTIC_GET_TOP_RECEIPT_CATEGORIES,
    effect: async () =>
      api.fetch('financial-statistics/top-categories', {
        categoryType: [RECEIPT],
        ...params
      }),
    onSuccess
  });
};

export const getPaymentTopCategories = (params, onSuccess) => async (
  dispatch
) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'financialStatistics',
    actionType: FINANCIALSTATISTIC_GET_TOP_PAYMENT_CATEGORIES,
    effect: async () =>
      api.fetch('financial-statistics/top-categories', {
        categoryType: [PAYMENT],
        ...params
      }),
    onSuccess
  });
};

export const getTotalLastMonth = (params, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'financialStatistics',
    actionType: FINANCIALSTATISTIC_GET_TOTAL_LAST_MONTH,
    effect: async () =>
      api.fetch('financial-statistics/total-movement-for-last-months', params),
    onSuccess
  });
};

export const getSummary = (params, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'financialStatistics',
    actionType: FINANCIALSTATISTIC_GET_SUMMARY,
    effect: async () => api.fetch('financial-statistics/summary', params),
    onSuccess
  });
};

export const getCashFlow = (params, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'financialStatistics',
    actionType: FINANCIALSTATISTIC_GET_CASHFLOW,
    effect: async () => api.fetch('financial-statistics/cash-flow', params),
    onSuccess
  });
};
